<template>
  <div class="select-video">
     <el-input v-model="src" placeholder="视频网络资源" style="width: 400px"></el-input>
     <el-button slot="trigger" size="small" @click="preview" type="primary">预览</el-button>
     <el-upload
        ref="upload"
        action="https://up-z2.qiniup.com"
        :on-success="handleUploadSuccess"
        :before-upload="beforeAvatarUpload"
        :auto-upload="true"
        :limit="1"
        :data="form"
      >
          <el-button slot="trigger" size="small" type="primary">选取视频文件</el-button>
      </el-upload>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'UploadVideo',
  components: {
  },
  props: {
    value: {
      type: String
    }
  },
  data () {
    return {
      src: '',
      form: {}
    }
  },
  mounted () {
  },
  watch: {
    src () {
      this.$emit('input', this.src)
    },
    value () {
      this.src = this.value
    }
  },
  methods: {
    preview () {
      if (!this.src) {
        this.$message.error('请上传文件')
        return false
      }
      window.open(this.src)
    },
    handleUploadSuccess(res) {
      // console.log(res)
      this.src = 'https://movie.artfilmonline.com/' + res.key
    },
    /// vue写获取token方法
    async getPicToken(key) {
        return await request({
                url: '/upload-token',
                method: 'post',
                data: {
                  key: key
                }
            })
    },
    async beforeAvatarUpload(file) {
       const fileType = file.type
       const current = new Date().getTime()
       const key = `video_${current}.mp4` // key为上传后文件名 必填
       const isLt20M = file.size / 1024 / 1024 < 1000 // 算出文件大小
       this.fileSize = file.size // 存储文件大小
       if (!isLt20M) { // 这里我们限制文件大小为20M
           this.$message.error('最大只能上传1000M!')
           this.$ref.upload.abort()
           return isLt20M
       }
       if (fileType !== 'video/mp4') { // 限制文件类型
           this.$message.error('只能上传MP4格式视频!')
           this.$ref.upload.abort()
           return false
       }
       try {
           let res = await this.getPicToken(key) 

           let token = res.data.token

           this.form = {
               key,
               token,
           }
           return true
       } catch (error) {
           return error
       }
    }
  }
}
</script>
<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// src/components/UploadVideo/index.vue